export default __webpack_public_path__ + "static/media/Armbands of Untamed Violence.a925482c.jpg";